<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-body pt-2 px-2">
        <div class="row mb-075 justify-content-sm-between justify-content-xl-start">
          <div class="col-md-3 col-12">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="filter_string" (ngModelChange)="getItems(); changeQueryParams()" />
          </div>
          <div class="col-md-3 col-12">
            <ng-select
              id="rating_candidate"
              [closeOnSelect]="true"
              [openOnEnter]="true"
              [virtualScroll]="true"
              [(ngModel)]="filter_rating"
              (ngModelChange)="getItems(); changeQueryParams()"
              [clearable]="!!filter_rating.id"
              (clear)="filter_rating = { id: null, name: null }"
            >
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "RATING" | translate }}: {{ item.name || ("ALL" | translate) }}</span>
              </ng-template>
              <ng-option [value]="{ id: null, name: null }">{{ "ALL" | translate }}</ng-option>
              <ng-option *ngFor="let item of candidateRatingsList" [value]="{ id: item.id, name: item.name }">{{ item.name }}</ng-option>
            </ng-select>
          </div>
          <div class="col-md-3 col-12" ngClass.sm="mb-075">
            <ng-select
              [closeOnSelect]="true"
              [openOnEnter]="true"
              [virtualScroll]="true"
              [clearable]="!!filter_city.id"
              (clear)="filter_city = { id: null, name: null }"
              [(ngModel)]="filter_city"
              (ngModelChange)="getItems(); changeQueryParams()"
            >
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CITY" | translate }}: {{ item.name || ("ALL_FEMALE_PLURAL" | translate) }}</span>
              </ng-template>
              <ng-option [value]="{ id: null, name: null }">{{ "ALL_FEMALE_PLURAL" | translate }}</ng-option>
              <ng-option *ngFor="let city of citiesList" [value]="{ id: city.id, name: city.nice_name }">{{ city.nice_name }}</ng-option>
            </ng-select>
          </div>
          <div *ngIf="_utilService.isDesktop" class="col-md-3 col-12 text-md-right">
            <div class="d-md-inline-block">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
            <a routerLink="/dashboard/candidate/add" class="btn btn-outline-primary" [ngClass.xl]="'ml-1'" has_capability="create_candidate">{{ "ADD" | translate }}</a>
          </div>
          <div *ngIf="!_utilService.isDesktop" [ngClass.md]="'col-3 text-right'" [ngClass.sm]="'col-12 text-center pt-1'">
            <a routerLink="/dashboard/candidate/add" class="btn btn-outline-primary" has_capability="create_candidate">{{ "ADD" | translate }}</a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-12" ngClass.sm="mb-1">
            <ng-select
              class="w-100"
              id="figure"
              [(ngModel)]="filter_figure"
              [closeOnSelect]="true"
              [openOnEnter]="true"
              [virtualScroll]="true"
              [clearable]="!!filter_figure.id"
              (clear)="filter_figure = { id: null, name: null }"
              (ngModelChange)="getItems(); changeQueryParams()"
            >
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "FIGURE" | translate }}: {{ item.name || ("ALL_FEMALE_PLURAL" | translate) }}</span>
              </ng-template>
              <ng-option [value]="{ id: null, name: null }">
                <span class="font-small-4 font-weight-normal">{{ "ALL_FIGURES" | translate }}</span>
              </ng-option>
              <ng-option *ngFor="let fig of _userFigureService.list" [value]="{ id: fig.id, name: fig.name }">
                <span class="font-small-4 font-weight-normal">{{ fig.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-md-3 col-12" ngClass.sm="mb-075">
            <ng-select
              id="skill-filter"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [multiple]="true"
              [(ngModel)]="filter_skill"
              (clear)="filter_skill = [0]"
              (ngModelChange)="changeSkill(); changeQueryParams()"
            >
              <ng-option [value]="0">
                <div class="font-small-4 font-weight-normal">{{ "ALL_SKILLS" | translate }}</div>
              </ng-option>
              <ng-option *ngFor="let skill of _skillService.list_enabled" [value]="skill.id">
                <span class="font-small-4 font-weight-normal">{{ skill.name }}</span>
              </ng-option>
              <ng-template ng-multi-label-tmp let-items="items" let-items$="items$" let-index="index" let-clear="clear" *ngIf="filter_skill.includes(0)">
                <div class="ng-select-selected-items">
                  <div *ngFor="let item of items; let last = last">
                    <div class="ng-value" *ngIf="item > 0">
                      <span>{{ item }}</span
                      ><span *ngIf="!last">, </span>
                    </div>
                    <div class="font-small-4 font-weight-normal empty" *ngIf="item < 1">
                      <span>{{ "ALL_SKILLS" | translate }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3 col-12" ngClass.sm="mb-075">
            <ng-select id="certifications-filter" [closeOnSelect]="true" [openOnEnter]="false" [virtualScroll]="true" [multiple]="false" [clearable]="!!filter_certification.id" (clear)="filter_certification={id: null, name: null}"
                       [(ngModel)]="filter_certification" (ngModelChange)="getItems(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CERTIFICATIONS" | translate }}: {{ item.name || ("ALL_FEMALE_PLURAL" | translate) }}</span>
              </ng-template>
              <ng-option [value]="{id: null, name: null}">
                <div class="font-small-4 font-weight-normal">{{ "ALL_FEMALE_PLURAL" | translate }}</div>
              </ng-option>
              <ng-option *ngFor="let cert of _certificationService.list" [value]="{id: cert.id, name: cert.name}">
                <span class="font-small-4 font-weight-normal">{{ cert.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-md-3 col-12">
            <ng-select
              id="recruiter-filter"
              [closeOnSelect]="true"
              [clearable]="!!filter_recruiter.hash"
              (clear)="filter_recruiter = { hash: null, name: null }"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [multiple]="false"
              [(ngModel)]="filter_recruiter"
              (ngModelChange)="getItems(); changeQueryParams()"
            >
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "INSERTED_BY" | translate }}: {{ item.name || ("ALL" | translate) }}</span>
              </ng-template>
              <ng-option value="all">
                <div class="font-small-4 font-weight-normal">{{ "INSERTED_BY" | translate }}</div>
              </ng-option>
              <ng-option *ngFor="let rec of _userService.recruiter_list" [value]="{ hash: rec.hash, name: rec.complete_name }">
                <span class="font-small-4 font-weight-normal">{{ rec.complete_name }}</span>
              </ng-option>
            </ng-select>

          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="50"
          [scrollbarH]="false"
          [rowHeight]="filter_skill.includes(0) && _utilService.isDesktop ? 70 : 140"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="candidatesFiltered"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
          [offset]="pageNumber"
          (page)="setPage($event)"
        >
          <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="firstname" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center {{ row?.judgment_name ? 'rating-point-candidate' : null }}" [ngbTooltip]="row.judgment_name ? row.judgment_name : null"
                   style="--color-rating: {{ row.judgment_color ? row.judgment_color : null }}">
                <div class="cell-line-height">
                  <a routerLink="/dashboard/candidate/edit/{{ row.hash }}">{{ row.firstname }} {{ row.lastname }}</a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'LAST_UPDATE_DATE' | translate" prop="update_date" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div>{{ row.date | date: "dd/MM/yyyy" }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FIGURE' | translate" prop="figure_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div>{{ row.figure_name || "" }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CITY' | translate" prop="working_city_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div class="mr-1 ml-0">
                  <i class="feather font-medium-3"></i>
                </div>
                <div>{{ row.working_city_name || "" }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TOTAL_DAILY' | translate" prop="desired_total_daily" [sortable]="true" has_capability="candidate_view_costs" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div>{{ (row.desired_total_daily || "0")  | currency:"EUR" }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NOTICE_RESIGNATION' | translate" prop="current_notice_resignation" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <div *ngIf="notice_times[row.current_notice_resignation]">{{ notice_times[row.current_notice_resignation] }}</div>
                <div *ngIf="!notice_times[row.current_notice_resignation]">{{ "FIELD_NOT_SPECIFIED" | translate }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'SKILLS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div *ngFor="let skill of filterSkillsForCandidate(row.skills)">
                <div class="badge badge-pill" [ngbTooltip]="_utilService.ucFirst(skill.level)" placement="top" [ngClass]="{ 'badge-light-dark': skill.level === 'junior', 'badge-info': skill.level === 'middle', 'badge-success': skill.level === 'senior'}">
                  {{ skill.skill_name }}
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CERTIFICATIONS' | translate" [sortable]="false" width="30" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="overflow-hidden w-100" *ngIf="row.certifications.length">
                <div *ngFor="let cert of filterCertificationsForCandidate(row.certifications); let l = last" [ngbTooltip]="cert.name" placement="left" class="badge badge-pill badge-secondary text-break-line-1 mw-100" [ngClass]="{'mb-025': !l}">{{ cert.name }}</div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="firstname" [sortable]="true" [width]="300" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-10 {{ row.judgment_name ? 'rating-point-candidate' : null }}" style="--color-rating: {{ row.judgment_color ? row.judgment_color : null }}">
                  <a routerLink="/dashboard/candidate/edit/{{ row.hash }}">{{ row.firstname }} {{ row.lastname }}</a>
                  <div>{{ row.figure_name || "" }}</div>
                </div>
                <div class="col-12 d-flex flex-wrap">
                  <div *ngFor="let skill of filterSkillsForCandidate(row.skills)">
                    <div class="badge badge-pill mr-1" [ngbTooltip]="_utilService.ucFirst(skill.level)" placement="top"
                         [ngClass]="skill.level === 'junior' ? 'badge-light-dark' : skill.level === 'middle' ? 'badge-info' : 'badge-success'">
                      {{ skill.skill_name }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
